/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {DayjsDateAdapter as ɵb,MAT_DAYJS_DATE_ADAPTER_OPTIONS_FACTORY as ɵa} from './lib/adapter/dayjs-date-adapter';